export default __webpack_public_path__ + "static/media/runButton.7db82b23.svg";